import type { EmotionJSX } from "@emotion/react/types/jsx-namespace";
import type { ComponentType } from "react";
import { RelayEnvironmentProvider } from "react-relay";

import { createClientUserServiceClientEnvironment } from "scmp-app/lib/relay/environment.client";

export function withUserServiceEnvironment<Props extends object>(Component: ComponentType<Props>) {
  const WrappedComponent = (props: Props) => (
    <RelayEnvironmentProvider environment={createClientUserServiceClientEnvironment()}>
      <Component {...(props as EmotionJSX.LibraryManagedAttributes<typeof Component, Props>)} />
    </RelayEnvironmentProvider>
  );
  return WrappedComponent;
}
